import { Component, OnDestroy, OnInit } from "@angular/core";
import { AddTrackingItemsDetailsComponent } from "../new-v2-component/add-tracking-items-details/add-tracking-items-details.component";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { NavigationService } from "src/app/providers/navigation.service";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-tracking-items-details",
  templateUrl: "./tracking-items-details.component.html",
  styleUrls: ["./tracking-items-details.component.scss"],
})
export class TrackingItemsDetailsComponent implements OnInit, OnDestroy {
    loader: boolean = false;
  apisub: Subscription;
  progressData: any = [];
    employeeHash: any = localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)

  constructor(
private router: Router,
    private route: ActivatedRoute,
    private ns: NavigationService,
    private dialog: MatDialog,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private dialogservice: DialogService
  ) {

    this.ns.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_PROGRESS_DATA_BY_TRACKER
      ) {
        this.progressData = [];
        if (resdata.result) {
          this.progressData = resdata.result;
          this.progressData.forEach((element: any) => {
            element.value =
              element.tracking_item_value + " " + (element.measurement_unit ?? '');
            element.notes = element.notes ? element.notes : "---";
          });
        }
        this.ls.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_DATA
      ) {
        if (resdata.result) {
          this.apiservice.getProgressDataByTracker(this.trackerHash);
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_TRACKER
      ) {
        if (resdata.result) {
          this.router.navigate(['../'],{relativeTo: this.route,queryParamsHandling: 'preserve'})
        }
      }
    });
  }


  trackerHash: any;
  memberHash: any;
  trackerName: any;
  ciot:any
  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.trackerHash = data.trackerHash;
        this.memberHash = data.memberHash;
        this.trackerName = data.trackerName;
      }
    });

        this.ciot = sessionStorage.getItem('ciot') && typeof sessionStorage.getItem('ciot') == 'string' ? JSON.parse(sessionStorage.getItem('ciot')!) : sessionStorage.getItem('ciot')


    this.loader = true;
    (this.ls.showLoader = true),
      this.apiservice.getProgressDataByTracker(this.trackerHash);
  }

  opentrackingitemsdetails() {
    this.router.navigate(["tracking-items-details"], {
      relativeTo: this.route,
    });
  }

  addrecorddata() {
    let data = {

       tracking_item_hash: this.trackerHash,
        trackingName: this.trackerName,
    };

    let dialogref = this.dialogservice.openFullScreenDialog(
      AddTrackingItemsDetailsComponent,
      data
    );
     dialogref.afterClosed().subscribe((data) => {
      if (data) {
        this.apiservice.getProgressDataByTracker(this.trackerHash);
      }
    });
  }

tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "Measurement",
      columnProperty: "value",
    },
  
    {
      columnName: "Date",
      columnProperty: "creation_time",
    },
      {
      columnName: "Notes",
      columnProperty: "notes",
    },
  ];
  itemdata: any[] = [
    {
      value: "60.5 Kg",
      notes: "Left at reception, 3rd floor.",
      idate: "12 Sep 2025",
    },
    {
      value: "60.5 Kg",
      notes: "Estimated delivery updated to tomorrow.",
      idate: "04 Sep 2025",
    },
    {
      value: "60.5 Kg",
      notes: "Estimated delivery updated to tomorrow.",
      idate: "09 Sep 2025",
    },
    {
      value: "60.5 Kg",
      notes: "Estimated delivery updated to tomorrow.",
      idate: "02 Sep 2025",
    },
    {
      value: "70.5 Kg",
      notes: "Left at reception, 3rd floor.",
      idate: "01 Sep 2025",
    },
  ];

    deleteItem(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      // width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this record?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          hash_id: item.hash_id,
          tracking_item_hash: item.tracking_item_hash,

          status: 0,
          creation_time: this.formatDateString1(new Date()),
          creator_type: 2,
          created_by: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        };

        this.ls.showLoader = true;
        this.apiservice.addEditProgressData(obj);
      }
    });
  }

  deleteTracker() {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      // width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this tracking?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          hash_id: this.trackerHash,
          member_hash: this.memberHash,
          status: 0,
          creation_time: this.formatDateString1(new Date()),
          creator_type: 2,
          created_by: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        };

        this.ls.showLoader = true;
        this.apiservice.addEditProgressTracker(obj);
      }
    });
  }

  formatDateString1(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
